import { render, staticRenderFns } from "./Waybill.vue?vue&type=template&id=24e74fcf&scoped=true"
import script from "./Waybill.vue?vue&type=script&lang=js"
export * from "./Waybill.vue?vue&type=script&lang=js"
import style0 from "./Waybill.vue?vue&type=style&index=0&id=24e74fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e74fcf",
  null
  
)

export default component.exports